// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qa__success{margin-top:2rem;font-size:1.1rem;text-align:center;display:flex;flex-direction:column;align-items:center}.qa__reset-button{margin-top:1rem}`, "",{"version":3,"sources":["webpack://./src/components/ui/QASection/QASection.scss"],"names":[],"mappings":"AACI,aACI,eAAA,CACA,gBAAA,CACA,iBAAA,CACA,YAAA,CACA,qBAAA,CACA,kBAAA,CAGJ,kBACI,eAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
